import React from 'react'
import { Modal as ReactstrapModal, ModalProps } from 'reactstrap'

export const Modal: React.FC<ModalProps> = props => {
  return <ReactstrapModal {...props} />
}
